// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2Z9AT","legacyBtn":"MutateMid_legacyBtn__1_82u"};